import { Button } from "antd";
import React, { ReactNode, useCallback } from 'react';
import { openPopup2, POPUP_TYPE } from "../../../../contexts/PopupContext";
import { callEventTrackingOp, getTrackingOp, state, useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { KEY_SPLIT_CHECKLIST, STEP_STATUS } from "../../../../util/varibles/constants";
import { IPropsChildren } from "../../../../util/varibles/interface";
import ChecklistsForm from "../ChecklistsForm";
import ConfirmNextState from "./ConfirmNextState";

interface IProps extends IPropsChildren {
    className?: string
    name?: string | ReactNode,
    status?: STEP_STATUS
    isDone?: boolean
}

const NextStep: React.FC<IProps> = ({
    className = 'bt-primary min-h-[40px]',
    name,
    status,
    isDone = false,
    children
}) => {
    const [loading, set] = useTrackingOp(state => state.loading);
    const get = getTrackingOp();
    const { nextState } = callEventTrackingOp();

    const handleClick = useCallback(() => {
        const { step, op } = get();

        if (step === op?.operation.current_process || op?.operation.current_process === -1) {
            const { activity_log } = op;
            const { key } = activity_log[step + 1];
            const { checklists_v2 = [], operation_type } = op.operation;
            let checklists;
            if (isDone) {
                checklists = checklists_v2.filter(item => {
                    const { steps = [] } = item.required_map || {};
                    return steps.length === 0 || steps.some(sub => {
                        const value = sub.split(KEY_SPLIT_CHECKLIST);
                        return value[0] !== `${operation_type}` || (value[0] === `${operation_type}` && value[value.length - 1] === key);
                    })
                })

            } else {
                checklists = checklists_v2.filter(item => {
                    const { steps = [] } = item.required_map || {};
                    return steps.some(sub => {
                        const value = sub.split(KEY_SPLIT_CHECKLIST);
                        return value[0] === `${operation_type}` && value[value.length - 1] === key;
                    })
                })
            }

            if (checklists.length === 0) {
                openPopup2(<ConfirmNextState
                    isComplete={isDone}
                    name={name}
                    onOk={() => nextState({ group_ids: [], state: state[status || STEP_STATUS.STARTED] })}
                />)
            } else {
                openPopup2(<ChecklistsForm
                    data={op}
                    checklists={checklists}
                />, { modalProps: { title: "Checklists", width: '100%' }, popupType: POPUP_TYPE.DRAWER })
            }
        } else {
            set({ step: step + 1 });
        }

    }, [status, name, isDone, nextState, get, set])

    return <Button className={className} loading={!!loading} onClick={handleClick}>
        {children}
    </Button>
}

export default NextStep;
